itsoftApp.createModule("scrollActions", ["startLoad"], function () {
    var module = this;
    var registeredPlugin = false;
    var registeredScrollTriggerPlugin = false;
    const getScrollbarWidth = itsoftApp.utils.getScrollbarWidth;

    var initScrollActions = function (element, scrollTriggerFlag, cb, swiper) { 
        const initScrollExemplar = function () {
            if (!itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.headerHeight) {
                itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.headerHeight = true;
                itsoftApp.calculations.headerHeight = itsoftApp.utils.getHeaderHeight();
            }

            var headerHeight = itsoftApp.calculations.headerFixedHeight;

            if (cb && typeof cb === "function") {
                cb();
            } else {
                if (element.classList.contains("js-hash-nav")) {
                    let mm = gsap.matchMedia();
                    let links = gsap.utils.toArray("[data-color]");
                        
                    links.forEach((a, index) => {
                        let element = document.querySelector(a.getAttribute("href"));

                        mm.add("(max-width: 1023px)", () => {
                            ScrollTrigger.create({
                                trigger: element,
                                start: "top top+=" + (headerHeight + 20 + 66), // если высота шапки поменяется, возможно, придётся отредактировать
                                end: "bottom top+=" + (headerHeight + 20 + 66),
                                onToggle: self => self.isActive && setActive(a, index),
                                // markers: true
                            });
                        });

                        mm.add("(min-width: 1024px)", () => {
                            ScrollTrigger.create({
                                trigger: element,
                                start: "top top+=" + (headerHeight + 20), // если высота шапки поменяется, возможно, придётся отредактировать
                                end: "bottom top+=" + (headerHeight + 20),
                                onToggle: self => self.isActive && setActive(a, index),
                                // markers: true
                            });
                        });
                    });

                    function setActive(link, index) {
                        links.forEach(el => el.classList.remove("js-active"));

                        mm.add("(max-width: 1023px)", () => {
                            if (Swiper) {
                                Swiper.initedSliders["tabsButtons"].slideTo(index);
                            }
                        });

                        link.classList.add("js-active");
                    }
                } else if (element.classList.contains("js-batch")) {
                    const steps = element.querySelectorAll(".js-step");

                    if (element.classList.contains("js-effect")) {
                        const picture = document.querySelector(".js-effect-picture");

                        steps.forEach(function (step) {
                            gsap.set(step, {
                                autoAlpha: 0,
                                yPercent: 15
                            });
                        });

                        ScrollTrigger.batch(steps, {
                            start: "top 70%",
                            onEnter: batch => gsap.to(batch, {autoAlpha: 1, yPercent: 0, stagger: 0.2, duration: 2, ease: "0.61, 0.1, 0.38, 0.8"}),
                            ease: "0.61, 0.1, 0.38, 0.8"
                            // markers: true
                        })

                        if (picture) {
                            picture.classList.add("js-active");
                        }
                    } else if (element.classList.contains("js-problem")) {
                        const picture = document.querySelector(".js-effect-picture");
                        const steps2 = element.querySelectorAll(".js-bacteria-step");

                        steps.forEach(function (step) {
                            gsap.set(step, {
                                autoAlpha: 0,
                                yPercent: 100
                            });
                        });

                        steps2.forEach(function (step) {
                            gsap.set(step, {
                                autoAlpha: 0,
                                xPercent: -45
                            });
                        });

                        ScrollTrigger.batch(steps, {
                            start: "top 70%",
                            onEnter: batch => gsap.to(batch, {autoAlpha: 1, yPercent: 0, stagger: 0.4, duration: 2, ease: "0.61, 0.1, 0.38, 0.8"}),
                            ease: "0.61, 0.1, 0.38, 0.8"
                            // markers: true
                        })

                        ScrollTrigger.batch(steps2, {
                            start: "top 70%",
                            onEnter: batch => gsap.to(batch, {autoAlpha: 1, xPercent: 0, stagger: 0.1, duration: 2, ease: "0.61, 0.1, 0.38, 0.8"}),
                            ease: "0.61, 0.1, 0.38, 0.8"
                            // markers: true
                        })

                        if (picture) {
                            picture.classList.add("js-active");
                        }
                    } else {
                        const timelineScale = document.querySelector(".js-timeline-scale");

                        steps.forEach(function (step) {
                            gsap.set(step, {
                                autoAlpha: 0,
                                yPercent: 15
                            });
                        });

                        ScrollTrigger.batch(steps, {
                            start: "top 70%",
                            onEnter: batch => gsap.to(batch, {autoAlpha: 1, yPercent: 0, stagger: 0.3, duration: 2, ease: "0.68, 0.13, 0.42, 1.01"}),
                            ease: "0.68, 0.13, 0.42, 1.01"
                            // markers: true
                        })

                        if (timelineScale) {
                            timelineScale.classList.add("js-active");
                        }
                    }
                }
            }
        }

        new itsoftApp.modules.startLoad.callback(initScrollExemplar, itsoftApp.libraries.scrollTrigger);
    }

    module.callback = initScrollActions;
});